import { MutableRefObject, useContext, useEffect, useRef } from 'react'
import { AppContext, AppContextState, AppContextType } from '../AppContext'

export default function useAppContextRef() {
    const { state: appState } = useContext(AppContext) as AppContextType

    const appStateRef = useRef<AppContextState>(appState)

    useEffect(() => {
        appStateRef.current = appState
    }, [appState])

    return {
        appStateRef: appStateRef as MutableRefObject<AppContextState>,
    }
}
